module.exports = __webpack_public_path__ + "static/media/jsfiddle.1663aa37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/jsfiddle.png
// module id = 129
// module chunks = 0